import React, { useRef, ForwardedRef } from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions } from 'chart.js';
import { TPieChartEconomyActivities } from './types.d';

ChartJS.register(ArcElement, Tooltip, Legend);

const options: ChartOptions<'pie'> = {
  responsive: true,
  plugins: {
    legend: {
      position: 'bottom',
    },
  },
  maintainAspectRatio: false,
};

const PieChartEconomyActivities: React.FC<TPieChartEconomyActivities> = ({
  portfolioEconomicAct,
  bgColors,
}) => {
  const data = {
    labels: portfolioEconomicAct?.map((x) => `${x?.ACTIVIDADECONOMICA} - ${x?.CANTIDAD}`),
    datasets: [
      {
        data: portfolioEconomicAct?.map((x) => x?.PORCENTAJE),
        backgroundColor: bgColors,
        hoverBackgroundColor: bgColors,
        borderWidth: 1,
      },
    ],
  };

  const chartRef = useRef<ChartJS>(null);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        cursor: 'pointer',
      }}>
      <Pie ref={chartRef as ForwardedRef<any> | undefined} data={data} options={options} />
    </div>
  );
};

export default PieChartEconomyActivities;
